import { render } from "./NotificationSystem.vue?vue&type=template&id=3e69ab81&scoped=true"
import script from "./NotificationSystem.vue?vue&type=script&lang=js"
export * from "./NotificationSystem.vue?vue&type=script&lang=js"

import "./NotificationSystem.vue?vue&type=style&index=0&id=3e69ab81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e69ab81"]])

export default __exports__